import setBreakpoint from '/expert/mobile/setBreakpoint.js';
import getBreakpoint from '/expert/mobile/getBreakpoint.js';

export default { setBreakpoint, getBreakpoint };
